import { authenticatedApi } from '../../../shared/api/apiClientUtils.ts';
import type { BookingImageResponse } from '../types/bookingImage.ts';

export async function getBookingImages(
  allocationId: string
): Promise<BookingImageResponse[]> {
  const response = await authenticatedApi.get<BookingImageResponse[]>(
    `/api/mobile/v1/allocations/${allocationId}/images`
  );
  return response.data;
}
